export interface InteriorOption {
  id: string
  name: string
  thumbnail?: string
  selected?: boolean
}

export interface InteriorMenuItem {
  id: string
  name: string
  type: 'category' | 'item' | 'option'
  icon?: string
  children?: InteriorMenuItem[]
  options?: InteriorOption[]
  expanded?: boolean
  selected?: boolean
}

export const interiorMenuData: InteriorMenuItem[] = [
  {
    id: 'layouts',
    name: 'Layouts',
    type: 'category',
    children: [
      {
        id: 'plan-options',
        name: 'Plan Options',
        type: 'item',
      },
    ],
  },
  {
    id: 'main-options',
    name: 'Main Options',
    type: 'category',
    children: [
      {
        id: 'general',
        name: 'General',
        type: 'item',
      },
      {
        id: 'kitchen',
        name: 'Kitchen',
        type: 'item',
        children: [
          { id: 'kitchen-layout', name: 'Layout', type: 'item' },
          {
            id: 'refrigerator',
            name: 'Refrigerator',
            type: 'item',
            options: [
              {
                id: 'fridge-standard',
                name: 'Standard 30"',
                thumbnail:
                  'https://images.unsplash.com/photo-1536353284924-9220c464e262?w=300&h=300&fit=crop',
                selected: true,
              },
              {
                id: 'fridge-french-door',
                name: 'French Door 36"',
                thumbnail:
                  'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=300&h=300&fit=crop',
              },
              {
                id: 'fridge-side-by-side',
                name: 'Side-by-Side',
                thumbnail:
                  'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?w=300&h=300&fit=crop',
              },
              {
                id: 'fridge-counter-depth',
                name: 'Counter Depth',
                thumbnail:
                  'https://images.unsplash.com/photo-1571175443880-49e1d25b2bc5?w=300&h=300&fit=crop',
              },
              {
                id: 'fridge-smart',
                name: 'Smart Hub',
                thumbnail:
                  'https://images.unsplash.com/photo-1588854337236-6889d631faa8?w=300&h=300&fit=crop',
              },
              {
                id: 'fridge-panel-ready',
                name: 'Panel Ready',
                thumbnail:
                  'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=300&fit=crop',
              },
            ],
          },
          { id: 'cooktop', name: 'Cooktop', type: 'item' },
          {
            id: 'range-oven',
            name: 'Range Oven',
            type: 'item',
            options: [
              {
                id: 'standard',
                name: 'Standard',
                thumbnail:
                  'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=300&fit=crop',
                selected: true,
              },
              {
                id: 'level-1',
                name: 'Stainless Steel',
                thumbnail:
                  'https://images.unsplash.com/photo-1574269909862-7e1d70bb8078?w=300&h=300&fit=crop',
              },
              {
                id: 'level-2',
                name: 'Professional',
                thumbnail:
                  'https://images.unsplash.com/photo-1590794056226-79ef3a8147e1?w=300&h=300&fit=crop',
              },
              {
                id: 'level-3',
                name: 'Chef Series',
                thumbnail:
                  'https://images.unsplash.com/photo-1556911220-bff31c812dba?w=300&h=300&fit=crop',
              },
              {
                id: 'level-4',
                name: 'Commercial Grade',
                thumbnail:
                  'https://images.unsplash.com/photo-1584568694244-14fbdf83bd30?w=300&h=300&fit=crop',
              },
              {
                id: 'black-electric',
                name: 'Black Stainless',
                thumbnail:
                  'https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=300&h=300&fit=crop',
              },
              {
                id: 'black-gas',
                name: 'Matte Black',
                thumbnail:
                  'https://images.unsplash.com/photo-1556909172-54557c7e4fb7?w=300&h=300&fit=crop',
              },
            ],
          },
          {
            id: 'dishwasher',
            name: 'Dishwasher',
            type: 'item',
            options: [
              {
                id: 'dw-standard',
                name: 'Standard',
                thumbnail:
                  'https://images.unsplash.com/photo-1581622558663-b2e33377dfb2?w=300&h=300&fit=crop',
                selected: true,
              },
              {
                id: 'dw-quiet',
                name: 'Ultra Quiet',
                thumbnail:
                  'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=300&h=300&fit=crop',
              },
              {
                id: 'dw-third-rack',
                name: 'Third Rack',
                thumbnail:
                  'https://images.unsplash.com/photo-1556909114-44e3e70034e2?w=300&h=300&fit=crop',
              },
              {
                id: 'dw-panel-ready',
                name: 'Panel Ready',
                thumbnail:
                  'https://images.unsplash.com/photo-1556909172-54557c7e4fb7?w=300&h=300&fit=crop',
              },
              {
                id: 'dw-smart',
                name: 'Smart Connect',
                thumbnail:
                  'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=300&h=300&fit=crop',
              },
            ],
          },
          { id: 'wall-oven', name: 'Wall Oven', type: 'item' },
          {
            id: 'microwave',
            name: 'Microwave',
            type: 'item',
            options: [
              {
                id: 'mw-standard',
                name: 'Standard',
                thumbnail:
                  'https://images.unsplash.com/photo-1585659722983-3a675dabf23d?w=300&h=300&fit=crop',
                selected: true,
              },
              {
                id: 'mw-over-range',
                name: 'Over-the-Range',
                thumbnail:
                  'https://images.unsplash.com/photo-1574269909862-7e1d70bb8078?w=300&h=300&fit=crop',
              },
              {
                id: 'mw-drawer',
                name: 'Drawer Style',
                thumbnail:
                  'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=300&fit=crop',
              },
              {
                id: 'mw-built-in',
                name: 'Built-In',
                thumbnail:
                  'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=300&h=300&fit=crop',
              },
            ],
          },
          { id: 'hood-fan', name: 'Hood Fan', type: 'item' },
          {
            id: 'cabinet-profile',
            name: 'Cabinet Profile',
            type: 'item',
            children: [
              {
                id: 'cabinet-handle',
                name: 'Handle',
                type: 'item',
                children: [
                  { id: 'handle-model', name: 'Model', type: 'item' },
                  { id: 'handle-material', name: 'Material', type: 'item' },
                ],
              },
            ],
          },
          {
            id: 'upper-cabinet-finish',
            name: 'Upper Cabinet Finish',
            type: 'item',
          },
          {
            id: 'lower-cabinet-finish',
            name: 'Lower Cabinet Finish',
            type: 'item',
          },
          {
            id: 'countertop',
            name: 'Countertop',
            type: 'item',
            options: [
              {
                id: 'ct-laminate',
                name: 'Laminate',
                thumbnail:
                  'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=300&fit=crop',
                selected: true,
              },
              {
                id: 'ct-granite',
                name: 'Granite',
                thumbnail:
                  'https://images.unsplash.com/photo-1600585152220-90363fe7e115?w=300&h=300&fit=crop',
              },
              {
                id: 'ct-quartz',
                name: 'Quartz',
                thumbnail:
                  'https://images.unsplash.com/photo-1556909172-54557c7e4fb7?w=300&h=300&fit=crop',
              },
              {
                id: 'ct-marble',
                name: 'Marble',
                thumbnail:
                  'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=300&h=300&fit=crop',
              },
              {
                id: 'ct-butcher-block',
                name: 'Butcher Block',
                thumbnail:
                  'https://images.unsplash.com/photo-1556909114-44e3e70034e2?w=300&h=300&fit=crop',
              },
            ],
          },
          { id: 'backsplash', name: 'Backsplash', type: 'item' },
          { id: 'faucet', name: 'Faucet', type: 'item' },
          { id: 'faucet-finish', name: 'Faucet Finish', type: 'item' },
          { id: 'sink', name: 'Sink', type: 'item' },
          { id: 'sink-finish', name: 'Sink Finish', type: 'item' },
          { id: 'pot-filler', name: 'Pot Filler', type: 'item' },
        ],
      },
      {
        id: 'bathroom',
        name: 'Bathroom',
        type: 'item',
      },
      {
        id: 'laundry',
        name: 'Laundry',
        type: 'item',
      },
    ],
  },
  {
    id: 'basement-options',
    name: 'Basement Options',
    type: 'category',
    children: [
      { id: 'basement-general', name: 'General', type: 'item' },
      { id: 'basement-kitchen', name: 'Kitchen', type: 'item' },
      { id: 'basement-bathroom', name: 'Bathroom', type: 'item' },
      { id: 'basement-laundry', name: 'Laundry', type: 'item' },
    ],
  },
]
